import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import UserTypes from "components/auth/user-types";
import MerchandiserInvoicingStatuses from "data/merchandiser-invoicing-statuses";
import Spinner from "components/common/Spinner";
import {
    closeCustomModal,
    openCustomModal
} from "components/custom/modals";
import {
    fetchMerchandiserInvoicingCharges,
    fetchMerchandiserPdfInvoice,
    approveMerchandiserInvoices,
    submitMerchandiserInvoices
} from "api/menu/invoicing/actions";
import {
    deleteMiscChargeById,
} from "api/menu/master-files/misc-charges/actions";

import ListChargesHeader from "components/menu/invoicing/merchandiser/list-charges-header";
import ListChargesCharges from "components/menu/invoicing/merchandiser/list-charges-charges";
import filterCaseInsensitive from "../../../custom/forms/react-table-case-insensitive";

const ServiceReport = React.lazy(() =>
    import("components/menu/reporting/service-report"));
const ViewChargeModal = React.lazy(() =>
    import("components/menu/invoicing/merchandiser/view-charge-modal"));

class ListCharges extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.statusesArray = Object.keys(MerchandiserInvoicingStatuses)
            .map(key => ({
                label: MerchandiserInvoicingStatuses[key].title,
                value: MerchandiserInvoicingStatuses[key].value
            }));

        this.viewReport = this.viewReport.bind(this);
        this.handleToggleSelectedCharges = this.handleToggleSelectedCharges.bind(this);

        this.handleView = this.handleView.bind(this);

        this.props.handleLoad();
    }

    handleToggleSelectedCharges = (chargeId = false, ref = null) => {
        let selectedCharges = Object.assign({}, this.props.selectedCharges);
        if (chargeId) {
            if (selectedCharges[chargeId]) {
                delete selectedCharges[chargeId];
            } else {
                selectedCharges[chargeId] = true;
            }
        } else if (Object.keys(selectedCharges).length) {
            selectedCharges = {};
        } else {
            const { charges } = this.props;
            if (ref) {
                const data = ref.current.getResolvedState().sortedData;
                data.forEach(item => {
                    selectedCharges[item._original.chargeId] = true;
                });
            } else {
                (charges && charges.charges ? charges.charges : []).forEach(item => {
                    selectedCharges[item.chargeId] = true;
                });
            }
        }

        this.props.setSelectedCharges(selectedCharges);
    };

    viewReport = (serviceId) => {
        const modalObj = {
            id: "view-report",
            modalSettings: {
                size: "lg",
                style: {
                    top: 20,
                    width: "calc(100% - 40px)"
                },
            },
            header: `Service Report: ${serviceId}`,
            children: (
                <React.Suspense
                    fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <ServiceReport
                        serviceId={serviceId}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        onSave={() => {
                            this.props.closeCustomModal(modalObj);
                        }}
                        onSubmit={() => {
                            this.props.closeCustomModal(modalObj);
                        }}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    handleView = (chargeId) => {
        const modalObj = {
            id: "view-misc-charge",
            modalSettings: {
                size: "sm",
            },
            header: `View Charge Detail ID: ${chargeId}`,
            children: (
                <React.Suspense
                    fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <ViewChargeModal
                        chargeId={chargeId}
                        onViewReport={this.viewReport}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        onSave={() => {
                            this.props.handleLoad();
                            this.props.closeCustomModal(modalObj);
                        }}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };
    render() {
        const {
            loading,
            charges,
            userRole
        } = this.props;

        const isAdminView = userRole.includes(UserTypes.admin);
        const isAccountManagerView = userRole.includes(UserTypes.accountManager);

        return (
            <div className="position-relative">
                {!loading || <Spinner/>}

                <ListChargesHeader
                    handleLoad={this.props.handleLoad}
                    handleViewPreliminaryInvoice={this.props.handleViewPreliminaryInvoice}
                    handleSelect={this.props.handleSelect}
                    handleApprove={this.props.handleApprove}
                    handleSubmitInvoice={this.props.handleSubmitInvoice}
                    submitIsDisabled={!(charges && charges.charges ? charges.charges : []).length}
                    filters={this.props.filters}
                />

                <div className="mb-4">
                    <ListChargesCharges
                        userRole={userRole}
                        charges={charges && charges.charges ? charges.charges : []}
                        onToggle={this.handleToggleSelectedCharges}
                        isAdminView={isAdminView}
                        isAccountManagerView={isAccountManagerView}
                        selectedCharges={this.props.selectedCharges}
                        onViewReport={this.viewReport}
                        onView={this.handleView}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: state.auth.user,
    userRole: state.auth.user.role,
    loading: state.invoicing.loading,
    charges: state.invoicing.charges
});

const mapStateToDispatch = dispatch => ({
    fetchMerchandiserInvoicingCharges:
        bindActionCreators(fetchMerchandiserInvoicingCharges, dispatch),
    fetchMerchandiserPdfInvoice: bindActionCreators(fetchMerchandiserPdfInvoice, dispatch),
    approveMerchandiserInvoices: bindActionCreators(approveMerchandiserInvoices, dispatch),
    submitMerchandiserInvoices: bindActionCreators(submitMerchandiserInvoices, dispatch),

    deleteMiscChargeById: bindActionCreators(deleteMiscChargeById, dispatch),

    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ListCharges);
